import React from "react"
import { Route } from "react-router-dom"
import { AuthContext } from "context"
import { CLOSING__RETENTION_PATH, CLOSING_PATH, CONFIGURATION_PATH, EXCEPTION_PATH } from "lib"
import { Exceptions } from "pages"
import ConfigurationRetention from "pages/Configuration/ConfigurationRetention"

const ClosingRetention = () => {
    const { user } = React.useContext(AuthContext)
    return (
        <React.Fragment>
            {
                Boolean(user) &&
                <React.Fragment>
                    <Route strict path={`${CLOSING__RETENTION_PATH}${CONFIGURATION_PATH}`} component={ConfigurationRetention} />
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default ClosingRetention
